import apiReq from '../commontools/api.js'
export function LoginByPwd(mobile, pwd) {

	var url = '/MCusInfo/LoginByPwd/' + mobile + '/' + pwd;
	return apiReq.get(url)
}
export function LoginByVcode(mobile, vcode) {

	var url = '/MCusInfo/LoginByVcode/' + mobile + '/' + vcode;
	return apiReq.get(url)
}
export function GetVcode(mobile) {

	var url = '/MCusInfo/GetVcode/' + mobile;
	return apiReq.get(url)
}
export function GetMyShopCart(mobile) {

	var url = '/Shop/GetMyShopCart/' + mobile;
	return apiReq.get(url)
}
export function AddShopCart(info) {
	var url = '/Shop/AddShopCart';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function CommitShopOrder(infos) {
	var url='/Shop/CommitShopOrder';
		var p = {
			data: infos
		}
		return apiReq.post(url,p);
}
export function PayShopOrder(mobile,morderid) {
	// var url = '/Shop/PayShopOrder/' + mobile+'/'+morderid;
	// return apiReq.get(url)
	var url='/Shop/PayShopOrder/' + mobile;
		var p = {
			data:{
				out_trade_no: morderid
			}
		}
		return apiReq.post(url,p);
}
export function GetShopOrderDetailByID(morderid) {
	var url = '/Shop/GetShopOrderDetailByID/' +morderid;
	return apiReq.get(url)
}
export function GetMyShopOrder(mobile) {
	var url = '/Shop/GetMyShopOrder/' +mobile;
	return apiReq.get(url)
}
export function GetShopOrderByID(morderid) {
	var url = '/Shop/GetShopOrderByID/' +morderid;
	return apiReq.get(url)
}
export function CancelShopOrder(morderid) {
	var url = '/Shop/CancelShopOrder/' +morderid;
	return apiReq.get(url)
}
export function DelShopCart(mobile,goodsid) {
	var url = '/Shop/DelShopCart/' +mobile+'/'+goodsid;
	return apiReq.get(url)
}
export function RefundShopOrder(morderid) {
	var url = '/Shop/RefundShopOrder/' +morderid;
	return apiReq.get(url)
}
export function UpdateShopOrderState(morderid,orderstatus) {
	var url = '/Shop/UpdateShopOrderState/' +morderid+'/'+orderstatus;
	return apiReq.get(url)
}

export default {
	LoginByPwd,
	LoginByVcode,
	GetVcode,
	GetMyShopCart,
	AddShopCart,
	CommitShopOrder,
	PayShopOrder,
	GetShopOrderDetailByID,
	GetMyShopOrder,
	GetShopOrderByID,
	CancelShopOrder,
	DelShopCart,
	RefundShopOrder,
	UpdateShopOrderState
}
